
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { register } from "../../../utils/auth";
import { useTranslation } from "react-i18next";

export const Register = () => {
    const navigate = useNavigate()
    const { i18n } = useTranslation();

    const [searchParams] = useSearchParams();
    const username = searchParams.get("username");
    const idClient = Number(searchParams.get("idClient"));
    const idSurvey = Number(searchParams.get("idSurvey"));
    const language = searchParams.get("language")
    const [hasRegistered, setHasRegistered] = useState(false);
    ;
    //http://localhost:5174/register?username=juane&idClient=1&idSurvey=1

    useEffect(() => {
        if (!hasRegistered && username) {
            setHasRegistered(true);
            register(username, idClient, idSurvey, language)
                .then((data) => {
                    console.log("Registro exitoso: " + data);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('username', data.user.username)
                    localStorage.setItem('idPersona', data.user.id)
                    i18n.changeLanguage(!language || language.trim().length === 0 ? "ca" : language);
                    navigate("/pending-surveys"); 
                })
                .catch((error) => {
                    console.error("Error to create survey for user:", error);
                    navigate("/login"); 
                });
        } else {
            navigate("/login"); 
        }
    }, [username, navigate]);

    return (
        <div>
            <p>Registrando usuario...</p>
        </div>
    );
};

